import { getTestId, BLACK_100 } from '@airtel/air-design-system';
var planInfo = [{
  heading: '100 GB',
  subHeading: 'per-day'
}, {
  heading: '28 days',
  subHeading: 'validity'
}];
export var keyPairUnitData = {
  data: [{
    description: 'validity',
    value: '30-day'
  }, {
    description: 'Calls',
    value: '10-Mins'
  }, {
    description: 'validity',
    value: '30-day'
  }, {
    description: 'Calls',
    value: '10-Mins'
  }],
  column: 2
};
var priceDetails = {
  price: '₹558',
  gstDetails: 'limit',
  oldPrice: '₹000',
  offerText: 'saved ₹100'
};
var additionalBenefits = [{
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'Free Hellotunes'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'Wync Music'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}];
var cardSliderBreakPoint = {
  xs: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  sm: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  md: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  lg: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  xl: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  }
};
var carouselData = {
  data: Array.from({
    length: 4
  }, () => ({
    imageUrl: {
      desktop: 'https://assets.airtel.in/static-assets/airtel-widgets/esim/images/mobile/hero-banner-1.jpg',
      mobile: 'https://assets.airtel.in/static-assets/airtel-widgets/esim/images/mobile/hero-banner-1.jpg'
    },
    title: 'Now start using Airtel eSIM in a 3 easy steps',
    subtitle: 'Enjoy the Hassle Free experience with your Airtel eSIM'
  })),
  carouselType: 'IMAGE',
  showNavigationCtas: false,
  showIndicators: false,
  breakPoints: cardSliderBreakPoint,
  onLeftNavigationPress: {},
  onRightNavigationPress: {},
  loop: true,
  heightConfig: {
    desktop: 176,
    mobile: 152
  }
};
var buttonWidgetData = {
  direction: 'row',
  leftCta: {
    buttonType: 'tertiary',
    title: 'view details',
    version: 'fixed-padding'
  },
  rightCta: {
    buttonType: 'secondary',
    title: 'buy',
    version: 'fixed-padding',
    style: {
      alignSelf: 'flex-end'
    }
  }
};
export var defaultProps = Object.assign({
  title: 'Infinity ₹499 plan',
  planInfo,
  hideRightChevronIcon: true,
  cardBorderColor: BLACK_100,
  additionalBenefits,
  hideDivider: true,
  infoTagArray: [{
    text: 'bestseller',
    subType: 'offer'
  }, {
    text: '1 regular + 1 free add-on SIM',
    subType: 'new'
  }],
  hideOttText: true,
  carouselData,
  buttonWidgetData,
  priceDetails,
  onLeftCtaPress: {
    id: 'onLeftCtaPress'
  },
  onRightCtaPress: {
    id: 'onRightCtaPress'
  },
  onCardPress: {
    id: 'onCardPress'
  }
}, getTestId('PackCardWidgetContainer'));